import Icon from '../components/Icon.vue'

Icon.register({
  'laugh-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM268.1 206.1C272.1 180.9 302.3 164 328 164S383.9 180.9 387.9 206.1C389.6 217.2 376.5 224.4 368.1 216.9L358.6 208.4C343.8 195.2 312.4 195.2 297.6 208.4L288 217C279.6 224.4 266.4 217.3 268.1 206.1zM168 160C185.7 160 200 174.3 200 192S185.7 224 168 224 136 209.7 136 192 150.3 160 168 160zM398.9 306C390 377 329.4 432 256 432H240C166.6 432 106 377 97.1 306 95.9 296.5 103.4 288 113 288H383C392.6 288 400.1 296.4 398.9 306z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh-wink.js
// module id = R82/
// module chunks = 144